import axios from "../../../../utils/request"

function GET_LIST(params) {
    return  axios.post("/statistics/TemplateUsedLog/templateList",{...params} )
}

function EXPORT(params) {
    return  axios.post("/statistics/TemplateUsedLog/templateListExport",{...params} )
}
export default {
    GET_LIST,
    EXPORT
}
